import { DatePipe, DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app.service';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DeleteFormVM, FormGroupedByCategoryVM, FormUploadVM, IdNameVM, SiteCodes, UpdateHistoryVM, UsersVM, VMDataForUpload } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { SafetyFormsService } from '../services/safety-forms.service';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { FileReaderEvent } from '../setup-implement/setup-implement.component';
import { ConfirmationMessageDeleteormsComponent } from './confirmation-message-deleteorms/confirmation-message-deleteorms.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-upload-form-edit',
  templateUrl: './upload-form-edit.component.html',
  styleUrls: ['./upload-form-edit.component.css'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})


// @Component({
//   selector: 'app-edit-digital-forms',
//   templateUrl: './edit-digital-forms.component.html',
//   styleUrls: ['./edit-digital-forms.component.css'],
//   providers: [
//     DatePipe,
//     {
//       provide: DateAdapter,
//       useClass: MomentDateAdapter,
//       deps: [MAT_DATE_LOCALE]
//     },
//     { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
//     { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
//   ],
// })
export class UploadFormEditComponent implements OnInit {

  fileData: File = null;
  today = new Date();
  constructor(private http: HttpClient,
    private SafetyFormsService_:SafetyFormsService,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private _sanitizer: DomSanitizer,
    private _safetyConfigService:SafetyConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private _inductionService: SafetyInductionService,
    public dialog: MatDialog,
    private _appService: AppService,
    private _notify: NotificationsService,
    @Inject(DOCUMENT) private document: Document) {
      this.today.setDate(this.today.getDate());
     }

    UploadFormId:number
    groupedForms:FormGroupedByCategoryVM[]
    Forms:FormGroupedByCategoryVM[];
    UploadData:VMDataForUpload
    incidentTypes: IdNameVM[]
    users:UsersVM[]=[]
    Image
  ImageList: string[] = [];
    selectedFile: FileList;
    siteCodesList: SiteCodes[]=[];
    dateCompleted
    inputForm
    reportIncidentID=""
    incidentType
    relatedUser
    inputValuestate
    Notes
    isActiveFollowUpRequired:boolean
    isActiveFollowUpCompleted:boolean
    fololowupDate
    fololowupUser
    FileName :string = "";
    NewFileName: string = "";
    FilePreview: string = "";
    FormCategoryId_
    FormUploadedData:FormUploadVM
    AddformID:number
    checkIsAdmin:boolean
    updateHistory:UpdateHistoryVM
    RequireIncidentNo:boolean
    isRequireIncidentNo:boolean=false
    isshowIncidentData:boolean=false
    AddedByUser
    DateAdded
    DateModified
    ModifiedByUser
    FormUploadData: FormUploadVM;
  downloadFileName: string
  FileList: string[] = [];
  UploadedFiles: string[] = [];
  UploadedImages: string[] = [];
  fileHeader = new Map();
  savingForm: boolean;
  isLoading: boolean = false;
  ngOnInit() {
    this.base64FileHeaderMapper();
    this.GetFormsAndFormCategories();
    this.GetIncidentTypesForDropDownLists();
    this.GetUsers();
    this.loadSiteList();
   // this.upload();

    // this.route.params.subscribe(params => {
    //   this.UploadFormId = +params['UploadId'];
     
    // });

    this.route.params.subscribe(params => {
      this.UploadFormId = +params['Id'];

      if (this.UploadFormId) {
        this.upload();
      }
  });
  this._appService.setPageTitle('Upload Forms');
  }

  sanitize(image: string) {
    console.log(Image)
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`); 
  }

  //uploadPhoto(newPhoto: string) {

  //  this.Image = newPhoto.split(",")[1];
  //  let Imgarray = [];
  //  Imgarray.push(this.Image);
  // if( this.ImageList!=null)
  // {
  //   this.ImageList.push(this.Image)
  // }
  // else
  //  this.ImageList=Imgarray
  //  console.log(this.ImageList)
  //}

  onSelectPhoto(event: any) {
    //if (event.target.files && event.target.files[0]) {
    //  var reader = new FileReader();
    //  this.selectedFile = event.target.files[0];
    //  reader.onloadend = (e) => {
    //    this.uploadPhoto(reader.result as string);
        
    //  }
    //  reader.readAsDataURL(event.target.files[0]);
    //}
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (this.UploadedImages.indexOf(event.target.files[i]["name"]) < 0) {
          this.UploadedImages.push(event.target.files[i]["name"]);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.ImageList.push(event.target["result"].split(",")[1])
          };
          reader.readAsDataURL(event.target.files[i]);
        }
      }
    }
  }
 
  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
}
 
onSubmit() {
    const formData = new FormData();
    formData.append('file', this.fileData);
    this.http.post('url/to/your/api', formData)
      .subscribe(res => {
        console.log(res);
        alert('SUCCESS !!');
      })
}

GetFormsAndFormCategories()
{
  this.SafetyFormsService_.GetActiveFormsForDropDownListisNotDigital().subscribe(res =>{ 
  this.groupedForms=res
  
  console.log("frm categories", this.groupedForms)
  
})

}

// GetFormsAndFormCategories() {
//  // this.loading = true
//   this.SafetyFormsService_.GetActiveFormsForDropDownList().subscribe(res => {
//     console.log("fom categories fpr drop down", res)
//     if (res.m_Item1) {

//       let arr = res.m_Item2
//       arr.Categories.map(c => {
//         let _forms = arr.Forms.filter(f => f.FormCategoryID == c.ID)
//         c.Forms = _forms
//       })
//       this.groupedForms = arr

//       console.log("arr", arr)
//     }


//     //this.loading = false
//   })
// }

GetIncidentTypesForDropDownLists()
{
  this.SafetyFormsService_.GetIncidentTypesForDropDownLists().subscribe(res=>
    {
      this.incidentTypes=res;
     // console.log("Incident types",this.incidentTypes)
    })
}

ClickForm(FormCat:FormGroupedByCategoryVM){
  console.log("Data__11", FormCat)
  if(FormCat.RequireIncidentNo == true){
    this.isRequireIncidentNo=true
  }else{
    this.isRequireIncidentNo=false;
  }
}
GetUsers()
{
  this._safetyGeneraldashboardService.GetUsersForSafetyApp().subscribe(res=>{
    this.users=res
 //   console.log("persons", res)
    // res.map(x=>{
    // //  this.UserName=x.UserName
    // }
    //   )    
  })
}

state = new FormControl("", [Validators.required]);
getErrorMessage() {
  return this.state.hasError("required") ? "You must enter a value" : "";
}

loadSiteList()
{
 this._safetyConfigService.getAllSitesList().subscribe(sites =>
 { 
  // console.log('sitelist',sites)
   this.siteCodesList=sites;
   
 });
}

onFileChanged(event) {
//  if (event.target.files && event.target.files[0]) {
//    var reader = new FileReader();

//    reader.readAsDataURL(event.target.files[0]); // read file as data url

////console.log("event.target.files[0]",event.target.files[0])
//    this.NewFileName = event.target.files[0].name
//    reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
//      var fileUrl = (event.target.result);


//      this.FilePreview = fileUrl;
//    }
//  }
  if (event.target.files && event.target.files[0]) {
    for (let i = 0; i < event.target.files.length; i++) {
      if (this.UploadedFiles.indexOf(event.target.files[i]["name"]) < 0) {
        this.UploadedFiles.push(event.target.files[i]["name"]);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.FileList.push(event.target["result"].split(",")[1])
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }
}

  Deletefilename(filename: any) {
    for (var i = 0; i < this.FileList.length; i++) {
      if (this.FileList[i]["name"] == filename) {
        this.FileList.splice(i, 1);
        this.UploadedFiles.splice(i, 1);
      }
    }
  }

  AddCompletedFormWithState() {
    if (this.dateCompleted == null) {
      this._notify.error('Please enter the Date Completed');

      return
    }
    else if (this.inputForm == null) {
      this._notify.error('Please select a form');

      return
    }

    // else if(this.FilePreview==""){
    //   this._notify.error('Please upload a file');
    //     return
    //   }
    // else if(this.reportIncidentID==null){
    //   alert('Please enter the Report/Incident ID.')
    //   return
    // }
    else if (this.inputValuestate == null || this.inputValuestate == 0) {
      this._notify.error('Please enter the State.');

      return
    }
    else {
      this.savingForm = true;
      let model = new FormUploadVM()
      model.Id = this.UploadFormId
      let selectedDate = new Date(this.dateCompleted);
      model.DateCompleted = selectedDate
      model.Form = this.inputForm
      model.IncidentId = this.reportIncidentID
      model.IncidentType = this.incidentType
      model.RelatedUser = this.relatedUser
      model.SiteId = this.inputValuestate
      model.Notes = this.Notes
      model.FollowUpRequired = this.isActiveFollowUpRequired
      model.FollowUpCompleted = this.isActiveFollowUpCompleted
      model.FollowUpDate = this.fololowupDate
      model.FollowUpUser = this.fololowupUser
      model.Images = this.ImageList
      model.FormFiles = this.FileList

      //model.FileName = this.NewFileName
      //if(this.FilePreview==null){
      //  this.FilePreview="";
      //}
      //var sImageUrl = this.FilePreview.replace(/^data:image\/[a-z]+;base64,/, "");
      //sImageUrl = this.FilePreview.replace(/^data:image\/\w+;base64,/, "");
      //model.File = this.FilePreview

      this.SafetyFormsService_.EditCompletedFormWithState(model).subscribe(res => {
        console.log("Addcompletedforms", res)
        // this.FormUploadedData=res
        //this.AddformID=res

        if (res) {
          this._notify.success('Successfully Saved');
          this.savingForm = false;
        }
        else {
          this._notify.error('Error', 'Unable to save data. Please contact TrackTreads support.');
          this.savingForm = false;
        }
      })
      //removed TT-5019
      // this.reload();
    }
  }

base64ToArrayBuffer(data) {
  var binaryString = window.atob(data);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
  }
  return bytes;
};

upload()
{
 // console.log(this.UploadFormId)
  this._inductionService.uploadFormData(this.UploadFormId).subscribe(resupload=>
    {
     this.UploadData=resupload
     console.log(this.UploadFormId)
     console.log('upload res', resupload)
     this.checkIsAdmin=resupload.IsAdmin
     this.updateHistory=resupload.UpdateHistory
     this.Forms=this.UploadData.Forms
     this.Forms.map(x=>{
      this.RequireIncidentNo=x.RequireIncidentNo
       if(this.RequireIncidentNo==true ||resupload.FormUploadData.FormCatId==1)
       {
        this.isRequireIncidentNo=true
       }
  else
  this.isRequireIncidentNo=false
  console.log(this.RequireIncidentNo)
})
  


  this.dateCompleted=resupload.FormUploadData.DateCompleted
  console.log(" this.dateCompleted",  this.dateCompleted)
  this.Notes=resupload.FormUploadData.Notes
  this.inputForm=resupload.FormUploadData.Form
  this.reportIncidentID=resupload.FormUploadData.IncidentId
  this.relatedUser=resupload.FormUploadData.RelatedUser
  this.inputValuestate=resupload.FormUploadData.SiteId
  this.isActiveFollowUpRequired=resupload.FormUploadData.FollowUpRequired
  this.isActiveFollowUpCompleted=resupload.FormUploadData.FollowUpCompleted
  this.fololowupDate=resupload.FormUploadData.FollowUpDate
  this.fololowupUser=resupload.FormUploadData.FollowUpUser
  this.ImageList=resupload.FormUploadData.Images
  this.FilePreview=resupload.FormUploadData.File
  this.NewFileName=resupload.FormUploadData.FileName
  this.downloadFileName=resupload.FormUploadData.File
  this.incidentType=resupload.FormUploadData.IncidentType
    this.FileList = resupload.FormUploadData.FormFiles
    })
}

//DownloadForm()
//{
//  var extention = this.NewFileName.split('.').pop();
//  var arrBuffer = this.base64ToArrayBuffer(this.downloadFileName);

//    if (extention == 'pdf') {
//      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
//      var link = document.createElement('a');
//      link.href = window.URL.createObjectURL(blob);
//      link.download = this.NewFileName;
//      link.click();
//    }
//    else if (extention == 'xls') {
//      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
//      var link = document.createElement('a');
//      link.href = window.URL.createObjectURL(blob);
//      link.download = this.NewFileName;
//      link.click();
//    }
//    else if (extention == 'docx') {
//      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
//      var link = document.createElement('a');
//      link.href = window.URL.createObjectURL(blob);
//      link.download = this.NewFileName;
//      link.click();
//    }

//    else if (extention == 'txt') {
//      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
//      var link = document.createElement('a');
//      link.href = window.URL.createObjectURL(blob);
//      link.download = this.NewFileName
//      link.click();
//    }
//    else if (extention == 'doc') {
//      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
//      var link = document.createElement('a');
//      link.href = window.URL.createObjectURL(blob);
//      link.download = this.NewFileName;
//      link.click();
//    }
//}

  DownloadForm(indx) {
    var _FileData = this.FileList[indx];
    var extention = this.getFileType(_FileData);
    var arrBuffer = this.base64ToArrayBuffer(_FileData);

    if (extention == 'pdf') {
      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "UploadedFormFile.pdf";
      link.click();
    }
    else if (extention == 'xls' || extention == 'xlsx') {
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "UploadedFormFile." + extention;
      link.click();
    }
    else if (extention == 'doc'|| extention == 'docx') {
      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download ="UploadedFormDoc."+ extention;
          link.click();
    }
    //else if (extention == 'docx') {
    //  var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    //  var link = document.createElement('a');
    //  link.href = window.URL.createObjectURL(blob);
    //  link.download = this.NewFileName;
    //  link.click();
    //}

    //else if (extention == 'txt') {
    //  var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
    //  var link = document.createElement('a');
    //  link.href = window.URL.createObjectURL(blob);
    //  link.download = this.NewFileName
    //  link.click();
    //}
    //else if (extention == 'doc') {
    //  var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    //  var link = document.createElement('a');
    //  link.href = window.URL.createObjectURL(blob);
    //  link.download = this.NewFileName;
    //  link.click();
    //}
  }

GetAdminLinkToAddUsers()
{
  this.router.navigate(['/administrator']);
  // this.SafetyFormsService_.GetAdminLinkToAddUsers().subscribe(res=>
  //   {
  //     console.log(res)
  //     window.open(res);
  //   })
}

@ViewChild('fileUploader') fileUploader:ElementRef;
@ViewChild('fileUploader_') fileUploader_:ElementRef;
reload(){
  window.location.reload();
//  this.dateCompleted = null;
//  //this.selectedForm = 0;
//  this.inputForm=0;
//  //this.NewFileName=""
//  this.reportIncidentID = "";
//  this.incidentType = 0;
//  this.inputValuestate=0;
//  this.ImageList = []; 
//  this.Image="";
//  //this.FilePreview='',
//  //this.NewFileName = "";
//  this.relatedUser = null;
//  this.Notes = "";
//  this.isActiveFollowUpRequired = false;
//  this.isActiveFollowUpCompleted = false;
//  this.fololowupDate = null;
//  this.fololowupUser = null;
//  this.fileUploader.nativeElement.value = null;
//  this.fileUploader_.nativeElement.value = null;



}
//removed TT-5019
//refresh(): void {
  
  //window.location.reload();
//}
Delete()
{
  this.savingForm = true;
  console.log("form ID" , this.AddformID)
  if(this.dateCompleted==null){
    
    this._notify.error('Please enter the Date Completed');
    this.savingForm = false;
    return
  }
 else if(this.inputForm==null){
  this._notify.error('Please select a form');
  this.savingForm = false;
    return
  }
  
// else if(this.FilePreview==""){
//   this._notify.error('Please upload a file');
   
//     return
//   }
  else{

  
      let model= new DeleteFormVM()
      model.Id=this.UploadFormId
    this.SafetyFormsService_.DeleteFormPaperForm(model).subscribe(res=>
      {
        
  
      this._notify.success('Successfully Deleted');
      this.savingForm = false;
      });

  
 
}
}

handleDOBChange(event) {
  let selectedDate = new Date(event);
 console.log("jjj",selectedDate)
 //this.dateCompleted=selectedDate
  // event.setDate(event.value.getDate() - 1);
   console.log("hhh",selectedDate.setDate(selectedDate.getDay() - 1))
}

openConfirmationDialog() {
  const dialogRef = this.dialog.open(ConfirmationMessageDeleteormsComponent, {
    data: {
     
    }
  });
  dialogRef.afterClosed().subscribe(res => {
    if (res == true) {    
      this.Delete(); 
          
    }
  });
}
  base64FileHeaderMapper() {
    //get the first 3 char of base64
    this.fileHeader.set("/9j", "jpg")
    this.fileHeader.set("iVB", "png")
    this.fileHeader.set("Qk0", "bmp")
    this.fileHeader.set("SUk", "tiff")
    this.fileHeader.set("JVB", "pdf")
    this.fileHeader.set("UEs", "doc")
    this.fileHeader.set("RXF", "xls")
    this.fileHeader.set("0M8", "xls")
  }

  getFileType(fileBase64) {
    let res = ""
    this.fileHeader.forEach((v, k) => {
      if (k == fileBase64.substr(0, 3)) {
        res = v
      }
    })
    //if file is not supported
    if (res == "") {
      res = "unknown"
    }
    //return map value
    return res;
  }

}

